import React, { useEffect, useState } from "react";

import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';

const WeekSelector = ({
  weeks = {}, // object like { "Week #1": "2025-05-05" }
  selectedWeeks, // Can be a single object { label, value }
  setSelectedWeek, // Function to update selected week
}) => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [search, setSearch] = useState('');
  const [weekList, setweekList] = useState([]);
  const toggleDropdown = () => setDropdownOpen((prev) => !prev);

  // Convert object to array of { label, value }

  useEffect(() => {
    console.log("weeks lable :",weeks);
    
    const weekList = Object.entries(weeks).map(([label, value]) => ({
      label,
      value,
    }));

    setweekList(weekList);
  }, [weeks]);

  const filteredWeeks = weekList.filter((week) =>
    week.label.toLowerCase().includes(search.toLowerCase()),
  );

  const handleSelectWeek = (week) => {
    setDropdownOpen(false); // Close dropdown on selection
    setSelectedWeek(week);
  };

  const handleClearSelection = () => {
    setDropdownOpen(false); // Close dropdown after clearing
    setSelectedWeek(null); // Set selectedWeeks to null to clear the selection
  };

  const isWeekSelected = (week) => {
    if (!selectedWeeks) {
      return false;
    }
    return selectedWeeks.value === week.value;
  };

  return (
    <Dropdown isOpen={dropdownOpen} direction="down" toggle={toggleDropdown}>
      <DropdownToggle
        caret
        className="btn btn-light week-bg text-black mb-3"
        disabled={weekList.length === 0}
      >
        <span className="text-black">
          {selectedWeeks?.label || 'Select Week'}{' '}
        </span>
        <i className="mdi mdi-chevron-down" />
      </DropdownToggle>

      <DropdownMenu className="p-2" style={{ minWidth: '220px' }}>
        {/* --- Clear Option Section --- */}
        {selectedWeeks && (
          <>
            <DropdownItem
              onClick={handleClearSelection}
              className="text-gray  text-center fw-bold" // Styling for emphasis
            >
              Clear Selection
            </DropdownItem>
            <div className="dropdown-divider"></div> {/* A visual separator */}
          </>
        )}

        {/* --- Week List Section --- */}
        {filteredWeeks.length === 0 && (
          <DropdownItem disabled>No results found</DropdownItem>
        )}

        {filteredWeeks.map((week, index) => (
          <DropdownItem
            key={index}
            onClick={() => {
              handleSelectWeek(week)
              toggleDropdown()
            }}
            className="d-flex align-items-center"
          >
            <input
              type="checkbox"
              className="form-check-input me-2"
              checked={isWeekSelected(week)}
              readOnly
            />
            {week.label}
          </DropdownItem>
        ))}
      </DropdownMenu>
    </Dropdown>
  );
};

export default WeekSelector;
